import { BASE_API } from "@/helpers/constants";
import axios from "axios";
import { TIMEOUT_MS } from "./constants";

// This is not used in the api client sdk.
// Created for other uses because the client does not export the axios instance
export const axiosInstance = axios.create({
  baseURL: BASE_API,
  withCredentials: true,
  timeout: TIMEOUT_MS,
  timeoutErrorMessage: `Request timed out after ${TIMEOUT_MS}ms`,
  headers: { "Content-Type": "application/json" },
});
